/** Shared carpool / schedule UI helpers (activity keys, ride status labels). */

const ACTIVITY_KEYS = ['school', 'sport', 'music', 'art', 'dance', 'other'];

/**
 * Normalizes API / DB activity to a known slug (lowercase, fallback `other`).
 */
export function normalizeActivityKey(activity) {
  if (activity == null) return 'other';
  const k = String(activity).trim().toLowerCase();
  return ACTIVITY_KEYS.includes(k) ? k : 'other';
}

/**
 * Localized label for carpool activity (use with i18n `t`).
 * @param {string} activity
 * @param {function} t - i18next t
 */
export function getActivityLabel(activity, t) {
  const key = normalizeActivityKey(activity);
  if (typeof t === 'function') {
    return t(`carpools.activityTypes.${key}`);
  }
  const fallback = {
    school: 'School',
    sport: 'Sport',
    music: 'Music',
    art: 'Art',
    dance: 'Dance',
    other: 'Other',
  };
  return fallback[key] || fallback.other;
}

/** @deprecated Prefer ActivityIcon / ActivityIconBadge + getActivityLabel */
export function activityEmoji(activity) {
  const map = {
    school: '🏫',
    sport: '⚽',
    music: '🎵',
    art: '🎨',
    dance: '💃',
    other: '📍',
  };
  const key = normalizeActivityKey(activity);
  return map[key] || map.other;
}

/** Maps API ride status to display meta (Dashboard, schedule views). */
export function rideStatusMeta(status) {
  const map = {
    scheduled: { icon: '📅', label: 'Планирано', color: '#6366f1' },
    in_progress: { icon: '🚗', label: 'В движение', color: '#f59e0b' },
    completed: { icon: '✅', label: 'Завършено', color: '#10b981' },
    cancelled: { icon: '❌', label: 'Отменено', color: '#ef4444' },
  };
  return map[status] || map.scheduled;
}
